var _path, _path2, _circle, _circle2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPmCcIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 50,
    viewBox: "0 0 62 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M61.6339 29.0114C64.7591 42.8461 47.1097 45.4179 37.8944 44.9745C29.831 45.988 11.7509 46.2287 3.93788 39.0833C-5.82834 30.1516 3.63738 10.5778 20.6156 4.49664C37.5938 -1.58454 57.7274 11.718 61.6339 29.0114Z",
    fill: "#FBFBFB"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6504 10.4031L22.3561 20.6501H19.5533L17.4416 12.4733C17.3116 11.969 17.2005 11.7855 16.8106 11.5714C16.1721 11.2261 15.1217 10.9023 14.1943 10.7006L14.2592 10.4032H18.7687C19.3438 10.4032 19.8609 10.7868 19.9909 11.4481L21.1075 17.3789L23.8654 10.4032H26.6504V10.4031ZM37.6291 17.3031C37.6415 14.6001 33.889 14.4529 33.9159 13.2437C33.9232 12.8746 34.2731 12.484 35.0393 12.3854C35.4197 12.3347 36.4668 12.2976 37.6535 12.8425L38.1186 10.6705C37.4801 10.4387 36.6594 10.2168 35.6393 10.2168C33.0194 10.2168 31.1751 11.6103 31.1595 13.6042C31.1423 15.0787 32.4754 15.9015 33.4809 16.3926C34.5133 16.895 34.8586 17.2159 34.8549 17.6665C34.8482 18.3542 34.0311 18.6548 33.269 18.6683C31.936 18.6891 31.1628 18.3081 30.5453 18.0205L30.0654 20.2672C30.6839 20.5511 31.8291 20.7977 33.0142 20.8122C35.7987 20.8121 37.6203 19.4334 37.6291 17.3031ZM44.5477 20.6502H46.9999L44.8602 10.4032H42.5964C42.0877 10.4032 41.6589 10.6998 41.4678 11.1543L37.4926 20.6502H40.275L40.8273 19.1199H44.2284L44.5477 20.6502ZM41.5898 17.0196L42.9857 13.172L43.7887 17.0196H41.5898ZM30.4385 10.4031L28.2453 20.6501H25.594L27.7878 10.4031H30.4385Z",
    fill: "#1A2ADF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 36.1275,
    cy: 33.1133,
    r: 9.02153,
    fill: "#F79E1C"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 25.0665,
    cy: 33.1133,
    r: 9.02153,
    fill: "#EA001B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M30.5951 40.2406C32.7194 38.5901 34.0863 36.0109 34.0863 33.1125C34.0863 30.2141 32.7194 27.6349 30.5951 25.9844C28.4709 27.6349 27.104 30.2141 27.104 33.1125C27.104 36.0109 28.4709 38.5901 30.5951 40.2406Z",
    fill: "#FF5F01"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPmCcIcon);
export default __webpack_public_path__ + "static/media/pm-cc-icon.4fc8f193d27b7de1119a9cff216dba7e.svg";
export { ForwardRef as ReactComponent };